export enum EUserRole {
  OWNER = 'owner',
  READER = 'reader',
}

// Enum with only non deprecated roles
export enum EUserRoleSelector {
  CO_OWNER = 'co_owner',
  READER = 'reader',
}

export const UserRoles = [...Object.values(EUserRole)]

export enum EUserPermission {
  HANDLE_BILLING = 'handle_billing',
  HANDLE_CREDITS = 'handle_credits',
  HANDLE_ENTERPRISES = 'handle_enterprises',
  HANDLE_USERS = 'handle_users',
  VIEW_REPORTS = 'view_reports',
  HANDLE_REPORTS = 'handle_reports',
  HANDLE_TOPICS = 'handle_topics',
  HANDLE_USE_CASES = 'handle_use_cases',
  HANDLE_WORKSPACES = 'handle_workspaces',
  HANDLE_TEAMS = 'handle_teams',
  HANDLE_MEMBERS = 'handle_members',
}

export interface IAuthorizedRoleParams {
  currentRole: EUserRole
  requiredRole: EUserRole
}

export const ETraductionKeysByUserRole = {
  [EUserRole.OWNER]: 'dashboard.roles.owner',
  [EUserRole.READER]: 'dashboard.roles.reader',
}
